<template>
  <div :class="$style.component">
    <div :class="$style.titleContainer">
      <div :class="$style.title">{{ label }}</div>
      <icon
          v-if="showInfo"
          @click.native="infoClicked"
          icon="info-filled"
          :class="$style.info"
      ></icon>
      <span v-if="optional" :class="$style.optional">{{optionalLabel}}</span>
    </div>
    <p :class="$style.description" v-if="hasSlotContent">
      <slot></slot>
    </p>
    <div :class="$style[size]">
      <div v-for="(val, key) in options" :key="key">
        <input
          :id="uniqueId + key"
          type="radio"
          :name="groupName"
          :value="key"
          :checked="key === value"
          @change="radioValueChanges(key)"
          :disabled="disabled"
        />
        <label :for="uniqueId + key" :class="$style.label">{{ val }}</label>
      </div>
    </div>
    <div>
        <slot name="result"></slot>
    </div>
  </div>
</template>

<script>
import icon from "../display/icon";
import { randomString } from "../../utils/string-util";

export default {
  name: "radio-group-fragment",
  components: { icon },
  props: {
    label: { type: String, required: true },
    showInfo: { type: Boolean, default: false },
    groupName: { type: String, required: true }, // Radio group name
    optional: { type: Boolean, default: false },
    optionalLabel: { type: String, default: "Optioneel" },
    value: { type: String },
    options: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    isInvalid: { type: Boolean, default: false },
    size: {
      type: String,
      default: "max",
      validator: function(value) {
        return ["small", "medium", "max"].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      uniqueId: ""
    };
  },
  computed: {
    hasSlotContent() {
      return this.$slots && this.$slots.default && this.$slots.default.length;
    }
  },
  beforeMount() {
    this.uniqueId = randomString();
  },
  methods: {
    radioValueChanges(newValue) {
      this.$emit("input", newValue);
    },
    infoClicked() {
      this.$emit("info-clicked");
    }
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors.scss";
@import "../../style/abstract/abstract.functions.scss";
@import "../../style/abstract/abstract.spacing.scss";
@import "../../style/abstract/abstract.typography.scss";
@import "../../style/modules/input.module.scss";

.component {
  [type="radio"] {
    display: none;
  }

  [type="radio"] + label {
    cursor: pointer;
    position: relative;
    color: $color-dimgrey;
    font-family: $font-family;
    align-items: center;
    display: grid;
    grid-template-columns: rem-calc(40px) auto;
  }

  [type="radio"] + label:after,
  [type="radio"] + label:before {
    content: "";
    border-radius: 100%;
    justify-self: center;
    grid-area: 1/1/2/2;
    margin-right: rem-calc($spacing-s);
  }

  [type="radio"] + label:before {
    background: $color-white;
    border: rem-calc(1) solid $color-dimgrey-lighter;
    width: rem-calc(25);
    height: rem-calc(25);
  }

  [type="radio"] + label:after {
    transition: all 0.2s;
    background: $color-primary;
    width: rem-calc(19);
    height: rem-calc(19);
    opacity: 0;
  }

  [type="radio"]:checked + label:after {
    opacity: 1;
  }
}

.regularFont {
  font-family: $font-family;
}

.label {
  display: flex;
  line-height: 1.3125;
  color: $color-dimgrey;
  composes: regularFont;
  font-size: rem-calc(15);
  margin-top: rem-calc($spacing-s);

  &:first-child {
    margin-top: rem-calc($spacing-m);
  }
}
</style>
